<template>

  <div
    style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
    <div style="position: relative; width: 100%; padding-bottom: 50%; max-width: 2000px;">
      <video ref="videoPlayer" :poster="posterImage" class="video-js vjs-default-skin" controls autoplay="autoplay"
        muted="muted" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></video>
    </div>
    <div v-if="isPlaylist" class="mb-4" style="margin-top: 10px;">
      <v-btn dark elevation="0" class="mr-3" @click="onPreviousClick">
        Previous
      </v-btn>
      <v-btn dark elevation="0" @click="onNextClick">
        Next
      </v-btn>
      <v-btn @click="jumpButton" style="display: none;" class="button jump">
        Play Third
      </v-btn>

    </div>
  </div>

</template>

<script>
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import 'videojs-playlist/dist/videojs-playlist.js';
import { mapState } from 'vuex';

export default {
  data: () => ({
    posterImage: null,
    videoList: [],
    isPlaylist: false,
    player: null,
  }),
  computed: {

  },
  methods: {
    onPreviousClick() {
      if (this.player && this.player.playlist) {
        this.player.playlist.previous();
      }
    },
    onNextClick() {
      if (this.player && this.player.playlist) {
        this.player.playlist.next();
      }
    },
    onJumpClick() {
      if (this.player && this.player.playlist) {
        this.player.playlist.currentItem(2);
      }
    },
  },
  mounted() {
    const types = { mp4: 'video/mp4', webm: 'video/webm', m3u: 'application/x-mpegURL' };
    const videoList = [];

    const localurl = window.location.href;
    const tmpNumber = localurl.replace(this.frontPreUrl + '/player?', '');
    const arr = tmpNumber.split(',');
    this.isPlaylist = arr.length > 1;

    for (let i = 0; i < arr.length; i++) {
      const add = {
        sources: [{
          src: decodeURIComponent(arr[i]),
          type: types.m3u
        }],

      };
      videoList.push(add);
    }

    this.player = videojs(this.$refs.videoPlayer, {
      inactivityTimeout: 0
    });
    this.player.playlist(videoList);


    this.player.playlist.autoadvance(0); 

    Array.prototype.forEach.call(document.querySelectorAll('[name=autoadvance]'), (el) => {
      el.addEventListener('click', () => {
        const value = document.querySelector('[name=autoadvance]:checked').value;
        this.player.playlist.autoadvance(JSON.parse(value));
      });
    });

    const Button = videojs.getComponent('Button');

    const PrevButton = videojs.extend(Button, {
      constructor: function () {
        Button.apply(this, arguments);
        this.addClass('icon-angle-left');
        this.controlText('Previous');
      },
      handleClick: function () {
        //console.log('click');
        this.player.playlist.previous();
      }
    });

    //videojs.registerComponent('NextButton', NextButton);
    videojs.registerComponent('PrevButton', PrevButton);
    this.player.getChild('controlBar').addChild('PrevButton', {}, 0);
    this.player.getChild('controlBar').addChild('NextButton', {}, 2);
  },
};
</script>

<style>
@import 'video.js/dist/video-js.min.css';
</style>
